import {
    Button,
    Card,
    CardContent,
    Grid,
    makeStyles,
    TextField,
    Typography
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { useNotify } from "react-admin";

import { Save } from "@material-ui/icons";
import { Autocomplete } from "@material-ui/lab";
import { AppContext } from "../../providers/app-context-provider/app.context";
import dataProvider from "../../providers/data-provider";

const useStyles = makeStyles((theme) => ({
    cardTitle: {
        fontSize: "1.1rem",
        fontWeight: 500,
        marginBottom: theme.spacing(2)
    },

    themes: {
        flexGrow: 1
    },
}));

const PreferredThemesCard = () => {

    const context = useContext(AppContext)
    const classes = useStyles();
    const notify = useNotify();
    const [themes, setThemes] = useState([]);
    const [selectedThemes, setSelectedThemes] = useState(context.favoriteThemes || [])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        dataProvider
            .get("themes", "", { sort: '"theme.name"', order: '"ASC"' })
            .then((res) => setThemes(res.data.data))
    }, [context]);

    const handleSubmit = () => {
        setLoading(true)
        dataProvider.post("user-contexts", "setFavoriteThemes", { themes: selectedThemes })
            .then((res) => {
                context.setFavoriteThemes(res.data.favorite_themes)
                notify('Áreas do Direito Preferidas salvas com sucesso!', 'success')
            })
            .finally(() => setLoading(false))
    }


    return (
        <Card>
            <CardContent>
                <Typography className={classes.cardTitle}>
                    Áreas do Direito Preferidas
                </Typography>

                <Typography variant="body2" color="textSecondary">
                    Selecione as áreas do Direito relacionadas à sua atuação.
                    Essas preferências serão utilizadas posteriormente
                    para personalizar filtros e recomendações.
                </Typography>
                <Grid direction="row" container alignItems="center" spacing={1}>
                    <Grid item className={classes.themes}>
                        <Autocomplete
                            options={themes}
                            getOptionLabel={(option) => option?.name}
                            value={selectedThemes}
                            onChange={(event, newValue) => setSelectedThemes(newValue)}
                            disabled={themes.length === 0}
                            multiple
                            getOptionDisabled={() => selectedThemes.length > 4}
                            filterSelectedOptions
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    required
                                    label="Áreas do direito"
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Save />}
                            disabled={loading}
                            onClick={handleSubmit}
                        >
                            {'Salvar'}
                        </Button>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
};

export default PreferredThemesCard;